import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Library, ChevronRight } from 'lucide-react';
import { getInternalGroupsSummary, getApiModulesSummary } from '../docsLoader';

const GroupCard = ({ item, testId }) => (
  <Link
    to={item.firstPath}
    data-testid={testId}
    className="group flex flex-col justify-between p-4 rounded-xl bg-slate-800/40 hover:bg-slate-800/80 border border-slate-700/60 hover:border-cyan-500/50 transition-all"
  >
    <div>
      <div className="flex items-start justify-between gap-2 mb-2">
        <span className="text-white font-semibold group-hover:text-cyan-400 transition-colors">
          {item.name}
        </span>
        <span className="shrink-0 text-xs font-mono text-cyan-400 bg-cyan-500/10 border border-cyan-500/20 px-2 py-0.5 rounded-full">
          {item.count}
        </span>
      </div>
      {item.description && (
        <p className="text-sm text-slate-400 leading-relaxed">
          {item.description}
        </p>
      )}
    </div>
    <div className="flex items-center gap-1 text-xs text-slate-500 group-hover:text-cyan-400 mt-3 transition-colors">
      <span>Ver funciones</span>
      <ChevronRight className="w-3 h-3" />
    </div>
  </Link>
);

const InternalApiHub = () => {
  const internalGroups = getInternalGroupsSummary();
  const apiModules = getApiModulesSummary();

  const totalInternal = internalGroups.reduce((s, g) => s + g.count, 0);
  const totalApi = apiModules.reduce((s, m) => s + m.count, 0);

  return (
    <div data-testid="internal-api-hub" className="space-y-12">
      <p className="text-slate-300 leading-relaxed">
        Blox incluye dos grandes conjuntos de funciones listas para usar. Las{' '}
        <strong className="text-white">Funciones Internas</strong> son parte del núcleo del
        lenguaje y siempre están disponibles. Las{' '}
        <strong className="text-white">Funciones de API</strong> vienen en archivos{' '}
        <code className="text-cyan-400 bg-cyan-950/50 px-1.5 py-0.5 rounded text-sm font-mono">.api</code>{' '}
        que debes incluir con <code className="text-cyan-400 bg-cyan-950/50 px-1.5 py-0.5 rounded text-sm font-mono">INCLUIR</code>.
      </p>

      {/* Funciones Internas */}
      <section>
        <div className="flex items-center gap-3 mb-4">
          <Package className="w-6 h-6 text-cyan-400" />
          <h2 className="text-2xl font-bold text-cyan-400 !m-0">Funciones Internas</h2>
          <span className="text-sm text-slate-500">
            {internalGroups.length} grupos · {totalInternal} funciones
          </span>
        </div>
        <p className="text-slate-400 mb-6">
          Siempre disponibles, sin necesidad de <code className="text-cyan-400 bg-cyan-950/50 px-1.5 py-0.5 rounded text-sm font-mono">INCLUIR</code>.
          Elige un grupo:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {internalGroups.map((g) => (
            <GroupCard key={g.id} item={g} testId={`hub-internal-${g.id}`} />
          ))}
        </div>
      </section>

      {/* Funciones de API */}
      <section>
        <div className="flex items-center gap-3 mb-4">
          <Library className="w-6 h-6 text-cyan-400" />
          <h2 className="text-2xl font-bold text-cyan-400 !m-0">Funciones de API</h2>
          <span className="text-sm text-slate-500">
            {apiModules.length} módulos · {totalApi} funciones
          </span>
        </div>
        <p className="text-slate-400 mb-6">
          Requieren <code className="text-cyan-400 bg-cyan-950/50 px-1.5 py-0.5 rounded text-sm font-mono">INCLUIR "nombre.api"</code> al inicio del programa.
          Elige un módulo:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {apiModules.map((m) => (
            <GroupCard key={m.id} item={m} testId={`hub-api-${m.id}`} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default InternalApiHub;
